/**
 * KYS Editorial Micro-Interaction System — RC1 Stabilization Pass
 * Lightweight ES6 helper for tactile pressed feedback, keyboard focus tracking, and loading states.
 * Excludes custom Horizon drawer triggers from pointer mutation to ensure 100% cart drawer reliability.
 */

(function () {
  'use strict';

  function isReducedMotion() {
    return Boolean(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  class KYSInteractions {
    constructor() {
      this.init();
    }

    init() {
      this.bindTactileFeedback();
      this.bindKeyboardFocus();
      this.bindLoadingStateListeners();
    }

    /* 1. Immediate Tactile Pointer Feedback */
    bindTactileFeedback() {
      if (isReducedMotion()) return;

      document.addEventListener(
        'pointerdown',
        (e) => {
          if (!e.target || !(e.target instanceof Element)) return;
          const target = e.target.closest(
            'button:not([on\\:click]):not([aria-controls="cart-drawer"]), .button:not([on\\:click]), a:not([on\\:click]), .kys-desktop-header__link:not(.kys-desktop-header__cart-trigger), .kys-fit__cta'
          );
          if (target && !target.hasAttribute('disabled')) {
            target.setAttribute('data-pressed', 'true');
          }
        },
        { passive: true }
      );

      const clearPressed = () => {
        document.querySelectorAll('[data-pressed="true"]').forEach((el) => {
          if (el) el.removeAttribute('data-pressed');
        });
      };

      document.addEventListener('pointerup', clearPressed, { passive: true });
      document.addEventListener('pointercancel', clearPressed, { passive: true });
    }

    /* 2. Keyboard Tab Navigation Focus Tracking */
    bindKeyboardFocus() {
      window.addEventListener(
        'keydown',
        (e) => {
          if (e.key === 'Tab') {
            document.body.setAttribute('data-keyboard-focus', 'true');
          }
        },
        { passive: true }
      );

      window.addEventListener(
        'pointerdown',
        () => {
          document.body.removeAttribute('data-keyboard-focus');
        },
        { passive: true }
      );
    }

    /* 3. Loading State Feedback for Forms & Cart */
    bindLoadingStateListeners() {
      document.addEventListener('submit', (e) => {
        const form = e.target;
        if (form instanceof HTMLFormElement) {
          const submitBtn = form.querySelector('[type="submit"]');
          if (submitBtn) {
            submitBtn.setAttribute('data-loading', 'true');
            setTimeout(() => {
              if (submitBtn) submitBtn.removeAttribute('data-loading');
            }, 3000);
          }
        }
      });

      document.addEventListener('cart:updated', () => {
        document.querySelectorAll('[data-loading="true"]').forEach((el) => {
          if (el) el.removeAttribute('data-loading');
        });
      });
    }
  }

  let interactionsInstance = null;
  function initInteractions() {
    if (!interactionsInstance) {
      interactionsInstance = new KYSInteractions();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initInteractions);
  } else {
    initInteractions();
  }
})();
